<template>
  <WizardContainer
    width="792px"
    height="624px"
  >
    <WizardContent>
      <template #flashMessage>
        <EduWarningFlashMessage :email="email" />
      </template>
      <h4 class="mt-6 mb-8">
        Provide Your Work Email
      </h4>
      <v-form
        ref="form"
        v-model="valid"
        class="form"
        @submit.prevent="submitForm"
      >
        <DpplTextField
          v-model="email"
          class="mb-3"
          label="Company Email"
          :rules="emailRules"
          validate-on="blur"
        />
        <DpplSignupFormButton
          class="mb-4"
          type="submit"
          block
          :loading="loading"
        >
          Submit
        </DpplSignupFormButton>
      </v-form>
      <WizardFooter>
        <h5>
          Having Issues?
          <a
            :href="'mailto:support@datapeople.io'
              + '?subject=Having%20issues%20provide%20work%20email%20on%20Datapeople'"
          >
            Contact Us
          </a>
        </h5>
      </WizardFooter>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';
import WizardFooter from '@/components/shared/WizardFooter.vue';
import { signupCreateAccount } from '@/api/signup';
import validation from '@/helpers/validation';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplSignupFormButton from '@/components/datapeople/DpplSignupFormButton.vue';
import EduWarningFlashMessage from '@/components/shared/EduWarningFlashMessage.vue';
import { mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'ProvideWorkEmail',
  components: {
    WizardContainer,
    WizardContent,
    WizardFooter,
    DpplTextField,
    DpplSignupFormButton,
    EduWarningFlashMessage,
  },
  emits: ['track-page-load'],
  data() {
    return {
      firstName: this.$route.params.firstName,
      lastName: this.$route.params.lastName,
      password: this.$route.params.password,
      email: '',
      emailRules: [
        (v) => !validation.isEmpty(v) || 'Email is required',
        (v) => validation.emailFormat(v) || 'Email format is invalid',
        (v) => validation.emailBlacklist(v) || 'Please provide your work email address.',
        (v) => validation.roleEmailBlacklist(v) || 'Role-based email addresses are not valid. Please use your individual company email address.',
        (v) => (v && v.length <= 250) || 'Email is too long',
      ],
      valid: false,
      loading: false,
    };
  },
  created() {
    if (!this.firstName || !this.lastName || !this.password) {
      this.$router.push({
        name: 'signup',
      });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Provide Work Email' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash']),
    async submitForm() {
      try {
        const formValidateResult = await this.$refs.form.validate();
        if (formValidateResult.valid) {
          this.loading = true;
          const responseJSON = await signupCreateAccount({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            password: this.password,
          });
          if (responseJSON.success === true) {
            this.$router.push({
              name: 'verify-email',
            });
          }
        }
      } catch (e) {
        if (!e.message || e.message.charAt(0) !== '{') {
          this.updateFlash({ message: `Create account error: ${e.message}` });
          throw e;
        }
        const responseJSON = JSON.parse(e.message);
        // if response contains please use corporate email error and no errors in other fields
        if ( // If only error is please include corporate email
          responseJSON.errors
          && responseJSON.errors.email
          && responseJSON.errors.email.includes('Please use your corporate email address.')
        ) {
          this.updateFlash({ message: 'Please use your corporate email address' });
        } else {
          this.updateFlash({ message: 'Something went wrong' });
        }
        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
}
</style>
